import Crud from '../views/Panico/Crud'
import View from '../views/Panico/View'

let routes = {
    path: '/cbo',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/panicos/view/:id?',
            name: 'ViewPanico',
            component: View,
            meta: {
                pageTitle: 'Visualizar ativação de pânico',
                breadcrumb: [
                    {
                        text: 'Pânicos',
                        active: false,
                        to: '/panicos',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/panicos',
            name: 'list-panicos',
            component: Crud,
            meta: {
                pageTitle: 'Ativações de pânico',
                breadcrumb: [
                    {
                        text: 'Pânicos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
